import { useEffect, useState } from "react";
import { Header } from "./inscription";
import { Link, useNavigate } from "react-router-dom";
import { RoundGreyPlain } from "components/ui/Buttons/generic/GenericButton";

const setDescription = (desc: any) => {
    const el = document.querySelector("meta[name='description']");
    if(el!== null){
        el.setAttribute('content',desc);
    }
}

export default function LostPass(){
    const [connecting, setConnecting]= useState(false);

    const [hasErrors, setHasErrors]= useState({status: false, message: ""});

    useEffect(()=> {
        document.title= "Connectez-vous à votre espace Wall of Share";
        const desc= "Connectez-vous à votre compte Wall of Share pour accéder à votre tableau de bord et gérer vos projets ou missions en toute simplicité.";
        setDescription(desc);
    },[]);

    const [credentials, setCredentials]= useState<{email: string}>({email: ""});
    const handleInputs= (event: any) => {
        event.preventDefault();
        setHasErrors({status: false, message: ""});
        if(!connecting) {
            setCredentials({...credentials, [event.currentTarget.id]: event.currentTarget.value});
        }
    };
    const history= useNavigate();

    const validate=(str: string)=>{
        return str.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    };

    const useConnectionAttempt= (event: any) => {
        event.preventDefault();
        if (validate(credentials.email)){
            setConnecting(true);
            (async ()=> {
                // const isUserEmail= await fetch('https://www.wall-of-share.com/check-mail');
                // const isUserEmail= await fetch('http://18.214.15.206/check-email?email=' + credentials.email);
                // const response= await fetch('https://cors-anywhere.herokuapp.com/https://www.wall-of-share.com/api/email/checker?email=' + credentials.email);
                const response= await fetch('https://www.portalwall-of-share.com/api/email/checker?email=' + credentials.email);
                // const response= await fetch('http://18.214.15.206/api/email/checker?email=' + credentials.email);
                const data= await response.json();
                if (data) {
                    console.log(data);
                    if (data.data.username_already_exist) {
                        history('/nouveau-mot-de-passe');
                    } else {
                        setConnecting(false);
                        setHasErrors({ status: true, message: "Cet email n'appartient pas à un utilisateur de Wall of Share." })
                    }
                } else {
                    console.log("no data");
                    console.log(response);
                }
            })();
        } else {
            setHasErrors({status: false, message: "Le format de l'email n'est pas valide."});
            return;
        }
        // history('/');
    };

    return<>
        <div className="w-full min-h-[100vh] bg-[#f4f4f5]">
            <Header backTo={"/connexion"}/>
            <div className="flex flex-col gap-[69px] items-center py-[110px] w-[80vw] max-w-[766px] mx-auto">
                <div className="flex flex-col gap-[10px] lg:max-w-[535px] max-w-[80vw] lg:mx-0 mx-auto self-start">
                    <h1 className="lg:text-[60px] lg:leading-[72px] text-[40px] leading-[48px] text-primary-blue font-semibold">Récupérez votre mot de passe.</h1>
                    <p className="lg:text-[25px] lg:leading-[32.55px] text-[20px] leading-[26.04px] text-[#6f6f6f] font-normal font-dm-sans">Entrez votre adresse e-mail ci-dessous et nous vous enverrons un lien pour réinitialiser votre mot de passe.</p>
                </div>
                <form onSubmit={useConnectionAttempt} className="w-full flex flex-col lg:max-w-[766px] max-w-[80vw] gap-[69px]">
                    <div className="flex flex-col gap-[10px] w-full">
                        <input type="email" className="w-full rounded-[100px] bg-white px-[30px] py-[20px] font-normal font-dm-sans md:text-[25px] md:leading-[32.55px] text-[20px] leading-[26.04px] text-[#6f6f6f]" id="email" placeholder="Votre adresse email" value={credentials.email} onChange={handleInputs} style={hasErrors.status? {border: "1px solid red"}: {}} />
                        {hasErrors.status && <div className="text-[#f55] lg:text-[25px] lg:leading-[32.55px] text-[20px] leading-[26.04px] font-normal font-dm-sans">{hasErrors.message}</div>}
                    </div>
                    <div className="flex flex-col gap-[28px] w-full">
                        <RoundGreyPlain isButton={true} className="w-full flex items-center justify-center py-[20px] md:text-[25px] md:leading-[30px] text-[20px] leading-[24px] font-semibold" text={connecting ? "Envoi..." : "Réinitialiser votre mot de passe"} onClick={useConnectionAttempt}/>
                        <p className="font-normal text-[20px] leading-[24px] text-primary-blue lg:text-left text-center max-w-[80vw] mx-auto md:mt-0 mt-[23.5px]">Vous n'avez pas encore de compte ? <Link className="font-semibold underline decoration-solid" to="/inscription">Inscrivez-vous</Link></p>
                    </div>
                </form>
            </div>
        </div>
    </>
};
